<template>
    <layout-main :banner="banner" subtitle="新闻资讯" :isTrue="false">
        <template v-slot:content>
            <div class="flex-box" v-for="(item,index) in newsList" :key="index">
                <div class="f-image">
                    <img :src="item.indexImage !='' ? item.indexImage : newImages" alt="" class="image">
                </div>
                <div class="f-text">
                    <p class="title">{{item.title}}</p>
                    <p class="text">{{ textContent(item.context) }}</p>
                    <p class="btn"  @click="setRouter(item)"> 查看详情</p>
                    <p class="time"> 发布时间：{{item.publishTime}}</p>
                </div>
            </div>
            <div class="page">
                <el-pagination background layout="prev, pager, next" :total="total" :current-page="page"  :page-size="10"  @current-change="handleCurrentChange" ></el-pagination>
            </div>
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/news/banner.png'
import { getListByPage } from '@/api/api'
import newImages from '@/assets/news/image.jpg'
export default {
    components: {
        layoutMain,
    },
    data () {
        return {
            banner: banner,
            newImages: newImages,
            newsList: [],
            page: 1,
            total: 0,
        }
    },
    methods: {
        handleCurrentChange (val){
            console.log(val);
            this.page = val;
            this.getNewsList();
        },
        textContent(htmlString) {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlString;
            var text = tempDiv.textContent || tempDiv.innerText || '';
            return text.trim();
        },
        getNewsList() {
            getListByPage({ page: this.page, limit: 10, isShow: 1}).then(res => {
                this.newsList = res.data.list;
                this.total = res.data.total;
            })
        },
        setRouter(val) {
            this.$router.push({ name: 'newsDetails', params: { obj: val }})
        }
    },
    mounted() {
        this.getNewsList()
    }
}
</script>
<style lang="scss" scoped>
.flex-box{
    height: 230px;
    display: flex;
    align-items: center;
    padding: 20px 0;
    margin-top: 20px;
    overflow: hidden;
    box-sizing: border-box;
    border-bottom: 2px solid #eee;
    .f-image{
        flex: 1;
        max-width: 180px;
        // height: 100%;
        .image{
            width: 100%;
            // height: 100%;
        }
    }
    .f-text{
        flex: 1;
        padding-left: 20px;
        box-sizing: border-box;
        text-align: left;
        .title{ 
            text-indent: 0em;
            font-size: 22px;
            font-weight: 600;
            text-align: left;
            margin: 0 !important;
        }
        .text{
            height: 45px;
            margin-top: 10px;
            text-indent: 0em;
            line-height: 1.3;
            overflow: hidden; /* 隐藏超出容器的内容 */
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; /* 最多显示两行 */
            text-overflow: ellipsis; /* 超出部分显示省略号 */
        }
        .btn{
            display: inline-block;
            padding: 8px 30px;
            color: #999;
            border: 1px solid #999;
            margin-top: 20px;
            cursor: pointer;
        }
        .time{
            margin-top: 20px;
            text-align: left;
            font-size: 14px;
            color: #999;
        }
    }
}
.flex-box:last-child{
    border: none;
}
.page{
    margin-top: 30px;
}
</style>
